import {
  InspectionState,
  DocumentStates,
  DocumentData,
  DocumentTextProcessing,
  PageRangeOption,
  PageWidthFit,
  DocumentTypes,
  ReportDocumentTypes,
  ShowLibrary,
  ZoomOptionState,
  ZoomLockLevel,
  DocumentToastState,
  PDFTRON_DEFAULT_TOOL,
  SortDifferencesOption,
} from 'types';

const initialDocumentState: DocumentData = {
  state: DocumentStates.INITIAL,
  pageRange: [],
  annotations: [],
  liveText: false,
  documentTextProcessing: DocumentTextProcessing.INITIAL,
  zoneSelectedTexts: [],
  pages: [],
  totalPageCount: 0,
  currentPage: 1,
  layers: undefined,
  separations: undefined,
};

const showLibrary: ShowLibrary = {
  [DocumentTypes.source]: false,
  [DocumentTypes.target]: false,
};

const zoomOption: ZoomOptionState = {
  [ReportDocumentTypes.report]: PageWidthFit.fitPage,
  [DocumentTypes.source]: PageWidthFit.fitPage,
  [DocumentTypes.target]: PageWidthFit.fitPage,
};

const zoomLockLevel: ZoomLockLevel = {
  [DocumentTypes.source]: null,
  [DocumentTypes.target]: null,
  [ReportDocumentTypes.report]: null,
};

const documentToast: DocumentToastState = {
  [DocumentTypes.source]: null,
  [DocumentTypes.target]: null,
};

const initialInspectionState: InspectionState = {
  source: initialDocumentState,
  target: initialDocumentState,
  report: initialDocumentState,
  selectedTool: PDFTRON_DEFAULT_TOOL,
  differenceViewOptions: {
    sortBy: SortDifferencesOption.readingOrder,
    filters: {},
    selectedModule: 'All',
    hideDisplayPanels: { [DocumentTypes.source]: false, [DocumentTypes.target]: false },
  },
  differencesLoaded: false,
  focusedDifferenceId: '-1',
  previousDifferenceId: '-1',
  syncScrolling: false,
  zoomChanging: false,
  noResultAnnotationId: '',
  invalidScaledGraphicZoneRatio: false,
  unconfirmTextZoneError: false,
  unconfirmedGraphicZoneError: false,
  unconfirmedMarqueeZoneError: false,
  manualSelectedZoneId: 0,
  manualSelectedAnnotationId: '',
  loadingInspection: false,
  name: '',
  inspectionId: '',
  inspectionStatus: '',
  lastJobId: null,
  lastJobInput: null,
  ctfJobs: [],
  zoomOption,
  showDiscarded: false,
  selectingZone: false,
  openPanel: false,
  pageRangeOption: PageRangeOption.ALL,
  zoomLockLevel,
  documentToast,
  showLibrary,
  internalAnnotationsVisibility: true,
  internalAnnotationsVisibilityDefault: true,
  tableEnhancementEnabledState: false,
  nextTextZoneId: 1,
  nextGraphicZoneId: 1,
  nextCropZoneId: 1,
  nextMarqueeZoneId: 1,
  nextCrossoutZoneId: 1,
  settings: {
    tableEnhancement: false,
    dictionaryName: undefined,
    fullPageGraphics: false,
    barcode: false,
    singleFile: false,
  },
  autoMatchGraphic: {
    autoMatchFail: 0,
    autoMatchPass: 0,
  },
  customDictionaryIDs: [],
  updatedAt: '',
  differencePanelOpen: false,
  changeGridDirection: 'ltr',
  shiftedGraphicRefId: '',
  selectedSubDifferenceId: '',
  subDifferenceComments: {},
  persistedDifferenceComments: {},
  isFilesLoaded: false,
  searchingForGraphicZone: false,
  reloadingDifferences: false,
  isBarcode: false,
  brailleLanguage: '',
  unmatchedPages: [],
  isResultsPanelHidden: false,
  flashMode: true,
};

export { initialDocumentState, initialInspectionState };
